import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-line bg-panel px-4 py-16 sm:py-20" aria-label="Frequently asked questions" data-id="element-108" data-mp="1ge8vool0cht0">
      <div className="mx-auto max-w-3xl" data-id="element-109" data-mp="2dyd9hc8c4czl">
        <SectionHeading kicker="Frequently asked questions" title="Everything you need to know" data-id="element-110" data-mp="290tidbqjg5q8" />

        <ul className="divide-y divide-line border-y border-line" data-id="element-111" data-mp="241qo8mc3jjx1">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} data-id="element-112" data-mp="1z5jhwsfsg6ek" data-mpi={i}>
                <h3 data-id="element-113" data-mp="snmo0yex0zjj">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-start justify-between gap-4 py-5 text-left text-[17px] font-bold text-white focus:outline-none focus-visible:text-amber" data-id="element-114" data-mp="so62u699r7tc">
                    {f.q}
                    <PlusIcon className={`mt-0.5 h-6 w-6 shrink-0 text-amber transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-115" data-mp="fji6p72fsafn" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-116" data-mp="3syo9o5jq8qyr">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-117" data-mp="3swtrgyzubcyd">
                      <p className="pb-5 text-[16px] leading-relaxed text-mist" data-id="element-118" data-mp="1uinwfkid5c2s">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <CtaButton className="mt-12" label="Get the Blueprint now" sub="One-time payment · No subscription" data-id="element-119" data-mp="1fsgklnmv2rb2" />
      </div>
    </section>;
}